import PropTypes from 'prop-types';

// Lib
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE
} from '@/lib/socialProfile';

import FacebookAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/facebook';
// Component
import InstagramAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/instagram';
import InstagramAlbumStory from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/instagram/InstagramAlbumStory';
import LinkedinAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/linkedin';
import PinterestAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/pinterest';
import TiktokAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/tiktok';
import TwitterAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/twitter';
import YoutubeAlbumPost from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/youtube';

const AlbumPost = ({ network, albumType, ...restProps }) => {
    switch (network) {
        case INSTAGRAM:
            if (albumType === 'stories') {
                return <InstagramAlbumStory {...restProps} />;
            }
            return <InstagramAlbumPost {...restProps} />;
        case FACEBOOK:
            return <FacebookAlbumPost {...restProps} />;
        case LINKEDIN:
            return <LinkedinAlbumPost {...restProps} />;
        case TWITTER:
            return <TwitterAlbumPost {...restProps} />;

        case TIKTOK_BUSINESS:
            return <TiktokAlbumPost {...restProps} />;
        case YOUTUBE:
            return <YoutubeAlbumPost {...restProps} />;
        case PINTEREST:
            return <PinterestAlbumPost {...restProps} />;
        default:
            return <InstagramAlbumPost {...restProps} />;
    }
};

AlbumPost.propTypes = {
    network: PropTypes.oneOf([
        INSTAGRAM,
        FACEBOOK,
        LINKEDIN,
        PINTEREST,
        TWITTER,
        TIKTOK_BUSINESS,
        YOUTUBE
    ])
};

export default AlbumPost;
